import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import question from "@/assets/images/question.svg";
import { getFaqTop10 } from "@/api/faq";
import { useLoadingStore } from "@/stores/loading";
import * as Common from "@/utils/common";
import { ResultItemProps, SearchTopFaq } from "@/types/faq";
import { useFaqSearch } from "@/stores/faqSearch";
import {useFaqFont} from "@/utils/useFaqFont";


export default function FaqSearchTop() {
  const setLoading = useLoadingStore(state => state.setLoading);
  const { setOrder, setBackPage } = useFaqSearch();
  const navigate = useNavigate();
  useFaqFont();

  const [lastModified, setLastModified] = useState("")
  const [newFaqList, setNewFaqList] = useState<SearchTopFaq[]>([])
  const [top10FaqList, setTop10FaqList] = useState<SearchTopFaq[]>([])

  const onClickNewList = () => {
    window.scrollTo(0, 0);
    setOrder("1");
    navigate("/faq_search");
  };

  const onClickRankingList = () => {
    window.scrollTo(0, 0);
    setOrder("2");
    navigate("/faq_search");
  };

  const onClickDetail = ( data_id: number ) => {
    setBackPage("/faq");
    navigate(`/faq/${data_id}`);
  };

  useEffect(() => {
    setLoading(true)
    getFaqTop10().then(result => {
      setNewFaqList(result.data.new_faq_list)
      setTop10FaqList(result.data.top10_faq_list)
      setLastModified(result.data.last_modified)
    }).catch(error => {
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  return (
    <div className="uk-flex uk-flex-column uk-flex-middle faq-font">
      <div className="sub-header">
        <p className="uk-faq-text-large uk-text-bold uk-margin-remove">
          よくある質問
        </p>
      </div>
      <div className="uk-width-3-4 uk-margin-top">
        <div className="uk-flex uk-flex-middle">
          <img src={question} alt=""/>
          <p className="uk-faq-text-medium-l uk-text-bold uk-margin-small-left">
            よくある質問（FAQ）
          </p>
        </div>
        <div className="uk-margin-top">
          <ul className="uk-tab attribute-tab">
            <li className="uk-active">
              <Link to="#">FAQ TOP</Link>
            </li>
            <li>
              <Link to="/faq_search">検索</Link>
            </li>
            <div className="right uk-flex">
              <p>更新日</p>
              <p className="uk-margin-small-left">{lastModified}</p>
            </div>
          </ul>
        </div>

        <div className="uk-flex uk-margin-large-bottom">
          <div className="uk-flex-1 uk-margin-top">
            <div className="faq-search-sub-title cursor-pointer" onClick={onClickNewList}>
              <p className="uk-faq-text-medium-l uk-text-bold">FAQ最新情報</p>
            </div>
            {newFaqList?.map(( faq, index ) =>
              <ResultItem faq={faq} index={index} key={index} onClickDetail={onClickDetail}/>)}
            <div className="uk-flex uk-flex-right margin-top-30">
              <button
                className="button-blue uk-margin-left"
                onClick={onClickNewList}
              >
                新着一覧
              </button>
            </div>
          </div>
          <div className="uk-flex-1 uk-margin-top uk-margin-left">
            <div className="faq-search-sub-title cursor-pointer" onClick={onClickRankingList}>
              <p className="uk-faq-text-medium-l uk-text-bold">ランキングTOP10</p>
            </div>
            {top10FaqList?.map(( faq, index ) =>
              <ResultItem faq={faq} index={index} key={index} onClickDetail={onClickDetail}/>)}
            <div className="uk-flex uk-flex-right margin-top-30">
              <button
                className="button-blue uk-margin-left"
                onClick={onClickRankingList}
              >
                ランキング一覧
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ResultItem = ( { faq, index, onClickDetail }: ResultItemProps ) => {
  return (
    <div className="faq-search-top-item" key={index} onClick={() => onClickDetail(faq.data_id)}>
      <p className="uk-text-bold uk-margin-left">{index + 1}</p>
      <p className="uk-faq-text-medium uk-margin-left">{faq.title}</p>
      {Common.isWithinLast15Days(faq.modified) && <p className="new margin-left-15">NEW</p>}
    </div>
  );
};